import React, { FunctionComponent } from "react";

export const NotFoundView: FunctionComponent = () => {
  return (
    <>
      <div className="d-flex justify-content-center fs-4">Page not found</div>
      <hr />
    </>
  );
};
